import { FsMatchTeams } from "./FsMatchTeams";
import { FsMatchSet } from "./Set/FsMatchSet";
import { FsMatchFormat } from "./FsMatchFormat";

export const BYE = "BYE";
export const TBD = "TBD";

export type FsMatch = {
  dqForceLast: boolean | undefined;
  ffForceLast: boolean | undefined;
  format: FsMatchFormat | undefined;
  ignore: boolean | undefined;
  isDelayed: boolean | undefined;
  numWinners: number | undefined;
  overrideComplete: boolean | undefined;
  scoreOverrides: { [id: string]: number } | undefined;
  sets: FsMatchSet[] | undefined;
  startTimeMs: number | undefined;
  teams: FsMatchTeams | undefined;
};
